<template>
  <footer class="footer">
    <div class="section-frame">
      <div class="footer-content">
        <router-link to="/" class="footer-logo">
          <img src="../assets/images/footer-logo.svg" alt="" />
        </router-link>
        <nav class="footer-nav footer-link">
          <ul>
            <li>
              <router-link to="/courses"
                ><div>{{ $t("all_courses") }}</div></router-link
              >
            </li>
            <li>
              <router-link to="/contact"
                ><div>{{ $t("contact") }}</div></router-link
              >
            </li>
          </ul>
        </nav>
        <nav class="footer-nav footer-contact">
          <ul style="flex-direction: column">
            <li style="margin-bottom: 5px">
              <a
                href="https://www.google.com/maps/place/%D0%94%D0%B0%D1%80%D1%85%D0%B0%D0%BD/@41.3201299,69.3017762,21z/data=!4m13!1m7!3m6!1s0x38aef4daa71348d5:0xd445686919eb85dc!2zODgg0JzRg9GB0YLQsNC60LjQu9C70LjQui3QsNCy0LXQvdGOLCDQotCw0YjQutC10L3Rgg!3b1!8m2!3d41.3195113!4d69.2997685!3m4!1s0x0:0x9ee62f4817372fb2!8m2!3d41.320242!4d69.3012787"
                target="_blank"
                ><i class="fa-map"></i>{{ $t("address") }}</a
              >
            </li>

            <li style="margin-bottom: 5px">
              <a href="tel:1355"><i class="fa-phone"></i>1355</a>
            </li>
          </ul>
        </nav>
        <ul class="social">
          <li>
            <a
              href="https://www.instagram.com/universalbank.uz/"
              target="_blank"
              ><i class="fa-instagram"></i
            ></a>
          </li>
          <li>
            <a href="https://www.facebook.com/universalbank.uz/" target="_blank"
              ><i class="fa-facebook"></i
            ></a>
          </li>
          <li>
            <a href="https://t.me/universalbank_uz" target="_blank"
              ><i class="fa-telegram"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
